import React, { useState } from 'react';
import { StandaloneSearchBox } from '@react-google-maps/api';

import FormInput from 'components/FormInput/FormInput';

const GoogleMapsSearch = props => {
  const [searchBox, setSearchBox] = useState({});
  const { onPlaceChange, onInputChange, form, defaultValue, label, requiredErrorMessage, style } = props;

  const handleOnPlacesChanged = () => {
    const foundPlace = searchBox.getPlaces()[0];
    let addressDisplayed;
    if (foundPlace && foundPlace.name && foundPlace.formatted_address) {
      addressDisplayed = `${foundPlace.name}, ${foundPlace.formatted_address}`;
      form.setFieldsValue({
        propertyAddress: addressDisplayed
      });
    }
    onPlaceChange({ ...foundPlace, addressDisplayed });
  };
  
  return (
    <StandaloneSearchBox onLoad={ref => setSearchBox(ref)} onPlacesChanged={handleOnPlacesChanged}>
      <FormInput
        form={form}
        name="propertyAddress" // Purpose: To stop chrome on autofill
        label={label}
        placeholder="Enter your address here to search hosts nearby"
        onChange={onInputChange}
        size="large"
        autoComplete="off"
        requiredErrorMessage={requiredErrorMessage}
        defaultValue={defaultValue}
        style={style}
      />
    </StandaloneSearchBox>
  );
};

GoogleMapsSearch.defaultProps = {
  label: '',
  onPlaceChange: () => {},
  onInputChange: () => {},
  requiredErrorMessage: '',
  style: {}
};

export default GoogleMapsSearch;
